var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLoadingImprovement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-\bLoadingImprovement"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.94 6.43L11 8.5L10.08 6.43L8 5.5L10.08 4.57L11 2.5L11.94 4.57L14 5.5L11.94 6.43ZM5 8.5L4.5 10.5L4 8.5L2 8L4 7.5L4.5 5.5L5 7.5L7 8L5 8.5ZM20 12.5V9.92L15.52 14.38C14.35 15.55 12.45 15.55 11.28 14.38L10.11 13.21C9.72 12.82 9.09 12.82 8.7 13.21L3.41 18.5L2 17.09L7.3 11.79C8.47 10.62 10.37 10.62 11.54 11.79L12.71 12.96C13.1 13.35 13.73 13.35 14.12 12.96L18.58 8.5H16V6.5H22V12.5H20Z",
    fill: "#565A5E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoadingImprovement);
export default __webpack_public_path__ + "static/media/Icon-LoadingImprovement.9f6310cd34af1a2fac1a6d536b02b14e.svg";
export { ForwardRef as ReactComponent };